export default __webpack_public_path__ + "static/media/googlelogo.415b8d9d.svg";